import moment from 'moment'
import { assetPrefix } from 'config/env_config'
import { SCHEDULING_STEPS } from 'src/utils/schedulingConstants'
import { getServiceIconByName, splitServiceName } from 'utils'

const FIELD_CONFIGS = {
  service: {
    stepName: 'Serviço',
    step: SCHEDULING_STEPS.PET_AND_SERVICE,
    infoIcon: (serviceName) => getServiceIconByName(serviceName, 'outline'),
    infoTitle: (serviceName) => splitServiceName(serviceName),
    infoAdditional: (selectedAdditionalServices) => {
      return (selectedAdditionalServices?.length ? '+ ' : '') + selectedAdditionalServices.map(additionalService => additionalService.name).join(', ')
    }
  },
  partner: {
    stepName: 'Localização',
    step: SCHEDULING_STEPS.PARTNER,
    infoIcon: () => `${assetPrefix}/static/icons/location-disabled.svg`
  },
  professional: {
    stepName: 'Profissional',
    step: (invertStep) => invertStep ? SCHEDULING_STEPS.DATE_AND_TIME : SCHEDULING_STEPS.PROFESSIONAL,
    infoIcon: () => `${assetPrefix}/static/icons/professional-disabled.svg`
  },
  datetime: {
    stepName: 'Data e Hora',
    step: (invertStep) => invertStep ? SCHEDULING_STEPS.PROFESSIONAL : SCHEDULING_STEPS.DATE_AND_TIME,
    infoIcon: () => `${assetPrefix}/static/icons/datetime-disabled.svg`
  },
  observations: {
    stepName: 'Serviço',
    step: SCHEDULING_STEPS.PET_AND_SERVICE,
    infoIcon: () => `${assetPrefix}/static/icons/comment.svg`
  }
}

export const getSchedulingInfoConfig = ({
  selectedService,
  selectedAdditionalServices,
  selectedPartner,
  selectedProfessional,
  selectedDay,
  selectedTime,
  obs,
  invertStep
}) => {
  const configs = []

  if (selectedService) {
    configs.push({
      infoTitle: FIELD_CONFIGS.service.infoTitle(selectedService.name),
      infoIcon: FIELD_CONFIGS.service.infoIcon(selectedService.name),
      infoAdditional: FIELD_CONFIGS.service.infoAdditional(selectedAdditionalServices),
      stepName: FIELD_CONFIGS.service.stepName,
      step: FIELD_CONFIGS.service.step,
      noEdit: false,
      fieldType: 'service'
    })
  }

  if (selectedPartner) {
    configs.push({
      infoTitle: selectedPartner.name,
      infoIcon: FIELD_CONFIGS.partner.infoIcon(),
      infoAdditional: selectedPartner.address,
      stepName: FIELD_CONFIGS.partner.stepName,
      step: FIELD_CONFIGS.partner.step,
      noEdit: false,
      fieldType: 'partner'
    })
  }

  if (selectedProfessional) {
    configs.push({
      infoTitle: selectedProfessional.name?.split('CNPJ')?.[0],
      infoIcon: FIELD_CONFIGS.professional.infoIcon(),
      stepName: FIELD_CONFIGS.professional.stepName,
      step: typeof FIELD_CONFIGS.professional.step === 'function'
        ? FIELD_CONFIGS.professional.step(invertStep)
        : FIELD_CONFIGS.professional.step,
      noEdit: false,
      fieldType: 'professional'
    })
  }

  if (selectedDay) {
    configs.push({
      infoTitle: moment(selectedDay).format('DD/MM/YYYY'),
      infoIcon: FIELD_CONFIGS.datetime.infoIcon(),
      infoAdditional: selectedTime,
      stepName: FIELD_CONFIGS.datetime.stepName,
      step: typeof FIELD_CONFIGS.datetime.step === 'function'
        ? FIELD_CONFIGS.datetime.step(invertStep)
        : FIELD_CONFIGS.datetime.step,
      noEdit: false,
      fieldType: 'datetime'
    })
  }

  if (obs) {
    configs.push({
      infoTitle: 'Observações',
      infoAdditional: obs,
      infoIcon: FIELD_CONFIGS.observations.infoIcon(),
      stepName: FIELD_CONFIGS.observations.stepName,
      step: FIELD_CONFIGS.observations.step,
      noEdit: false,
      fieldType: 'observations'
    })
  }

  return configs
}
